import { get } from '@bigyouth/base'

export default {
  name: 'tabs',

  ui: {
    'buttons[]': '[js-tabs-button]',
  },

  events: [
    {
      on: 'click',
      target: 'buttons',
      handle ({ target }) {
        const tab = target.dataset.tab

        // remove active classes
        get('[js-tabs-panel].is-active').classList.remove('is-active')
        get('[js-tabs-button].is-active').classList.remove('is-active')

        // add actives ones
        const currentPanel = get(`[js-tabs-panel][data-tab="${tab}"]`)

        target.classList.add('is-active')
        currentPanel.classList.add('is-active')

        const inAccordion = currentPanel.closest('[js-toggle-content-inner]')

        if (inAccordion) {
          const tabHeight = currentPanel.closest('[js-toggle-content-inner]')
            .offsetHeight
          currentPanel.closest(
            '[js-toggle-content-content]',
          ).style.height = `${tabHeight}px`
        }
      },
    },
  ],
}
